<main id="new-account-main-content">
  <div class="page-container">
    @if (isDesktopLayout) {
      <div class="column left">
        <div class="texts-container">
          <h1 class="main-title-text" [innerHTML]="'NEW_ACCOUNT.MAIN_TITLE' | translate" #mainTitleText></h1>
        </div>
      </div>
    }

    <div class="column right" [class.column--loading]="viewLoading">
      <div class="utils-buttons-wrapper">
        <app-utils-buttons (userLangChanged)="userLangChanged($event)"></app-utils-buttons>
      </div>

      <div class="content-column" [class.content-column--loading]="viewLoading">
        @if (!APIAvailable) {
          <app-new-account-api-unavailable-view></app-new-account-api-unavailable-view>
        }

        @if (APIAvailable && viewLoading) {
          <nz-spin
            class="mobiapp-spin no-children xlarge"
            [nzTip]="'COMMON.GENERAL.LOADING_APPLICATION_DATA' | translate"
            nzSize="large"
            [nzSpinning]="true"
            [nzIndicator]="LoadingIndicator"></nz-spin>
        }

        @if (APIAvailable && newAccountForm) {
          <div class="new-account-view-content" [class.new-account-view-content--preparing]="viewLoading">
            @if (isDesktopLayout) {
              <app-new-account-desktop-view></app-new-account-desktop-view>
            }

            @if (!isDesktopLayout) {
              <app-new-account-mobile-view></app-new-account-mobile-view>
            }
          </div>
        }
      </div>

      @if (!viewLoading) {
        <app-ue-finance-banner></app-ue-finance-banner>
      }
    </div>
  </div>
</main>

<ng-template #LoadingIndicator>
  <span nz-icon nzType="loading" class="ant-spin-dot"></span>
</ng-template>
<app-cookie-banner></app-cookie-banner>
